import saveListService from '@services/savelistservice'
import { useQuery } from 'react-query'

const fetchSavedLists = async (customerId, productDetails) => {
  const data = await saveListService.getSavedLists(customerId, productDetails)
  return {
    data: Array.isArray(data) ? data : [data],
  }
}

const useSavedlistsQuery = (customerId, productDetails) => {
  return useQuery(
    ['fetchSavedLists', customerId, productDetails],
    () => fetchSavedLists(customerId, productDetails),
    {
      enabled: !!customerId, // Only run the query if customerId exists (truthy)
    },
  )
}

export { fetchSavedLists, useSavedlistsQuery }
